import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const fireTransition = async (
	port: WorkItemPort,
	item: WorkItem,
	transitionId: string,
	ctx: ActorContext,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('fire_transition', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyAdvance')
		return null
	}
	try {
		const updated = await port.fireTransition(item.id, transitionId, ctx.actorId, ctx.actorName)
		notify.success('workItem.updated')
		return updated
	} catch {
		notify.error('workItem.transitionFailed')
		return null
	}
}

export { fireTransition }
